import Fields from './fields'
import Masked from './masked'

export default (Vue) => {
  Fields(Vue)
  Masked(Vue)
}



// WEBPACK FOOTER //
// ./src/components/form/index.js